import { render } from "./UniqueView.vue?vue&type=template&id=3deed14b"
import script from "./UniqueView.vue?vue&type=script&lang=js"
export * from "./UniqueView.vue?vue&type=script&lang=js"

import "./UniqueView.vue?vue&type=style&index=0&id=3deed14b&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_omroepwest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__